import { useEffect, useState } from "react";
import { ScheduleCard } from "../../components/public/schedule/ScheduleCard";
import { ScheduleTable } from "../../components/public/schedule/ScheduleTable";
import { usePublicStore } from "../../store/publicStore";
import "./Schedule.css";
import MainPageLayout from "../../components/layouts/MainPageLayout";
import { Busy } from "../../components/Busy";
import { Footer } from "../landing/Footer";

export const Schedule = () => {
  const { currentSeason, getCurrentSeason, isBusy } = usePublicStore();

  useEffect(() => {
    getCurrentSeason();
  }, [getCurrentSeason]);

  const [formattedData, setFormattedData] = useState<any[]>([]);

  useEffect(() => {
    if (!currentSeason) {
      return;
    }
    const data = currentSeason.seasonMatches;
    const formattedData = data.map((entry, index) => {
      const isFinals = entry.matchType.includes("FINALS");
      const isFirstInStage =
        index === 0 ||
        data[index - 1].groupOrKnockout !== entry.groupOrKnockout;
      const stageRowspan = isFirstInStage
        ? data.filter((e) => e.groupOrKnockout === entry.groupOrKnockout).length
        : undefined;
      return {
        ...entry,
        isFirstInStage,
        stageRowspan,
        isFinals,
      };
    });
    setFormattedData(formattedData);
  }, [currentSeason]);

  return (
    <MainPageLayout Footer={<Footer />}>
      <div className="py-3 px-2 pb-6">
        <h1 className="title">Game Schedule</h1>
        <div className="schedule-view">
          {currentSeason &&
            currentSeason.seasonMatches &&
            currentSeason.seasonMatches.length > 0 && (
              <>
                <div className="desktop-view">
                  <ScheduleTable data={formattedData} />
                </div>
                <div className="mobile-view">
                  {formattedData.map((entry) => (
                    <ScheduleCard key={entry.id} entry={entry} />
                  ))}
                </div>
              </>
            )}
            {(!currentSeason || !currentSeason.seasonMatches || currentSeason.seasonMatches.length === 0) && (
              <div className="text-center">No schedule available</div>
            )}
        </div>
        {isBusy && <Busy busyMessage={"Please wait..."} />}
      </div>
    </MainPageLayout>
  );
};
